export class PrestamoSave {
  fechaReservaInicio!: string;
  fechaReservaFin!: string;
  emailReservador: string | undefined;
  namesReservador!: string;
  tipoReserva!: string;
}
